import React from "react";

import { Box, Flex, Grid, GridItem, Text } from "@chakra-ui/react";

import { defaultValues } from "../../../defaultValues";
import { FilterDropDown } from "../../components/FilterDropDown";
import { FilterDropDownCertificacion } from "../../components/FilterDropDown/FilterDropDownCertificacion";

export const ComunicacionesHeader: React.FC = () => {
	return (
		<Box h=".5rem" background="transparent" p="0 1rem" mb=".5rem">
			<Flex width="100%" height="100%" alignItems="center">
				<Grid templateColumns="repeat(18, 1fr)" w="100%" pr="1.5rem" pl=".3rem">
					<GridItem colSpan={1} alignSelf="center">
						<FilterDropDown column="por_validar" values={defaultValues.por_validar} />
					</GridItem>
					<GridItem colSpan={4} alignSelf="center">
						<FilterDropDown column="nombre" />
					</GridItem>
					<GridItem colSpan={2} alignSelf="center">
						<FilterDropDown column="nec_indice" values={defaultValues.nec_indice} />
					</GridItem>
					<GridItem colSpan={2} alignSelf="center">
						<FilterDropDownCertificacion column="revised_at" />
					</GridItem>
					<GridItem colSpan={2} alignSelf="center">
						<FilterDropDown column="type" values={defaultValues.type} />
					</GridItem>
					<GridItem colSpan={2} alignSelf="center">
						<FilterDropDown column="recipients" />
					</GridItem>
					<GridItem colSpan={2} alignSelf="center">
						<FilterDropDownCertificacion column="response_date" />
					</GridItem>
					<GridItem colSpan={2} alignSelf="center">
						<Flex alignItems="center">
							<Text title="Histórico" color="gray.500" textStyle="body3" pl=".5rem">
								Histórico
							</Text>
						</Flex>
					</GridItem>
				</Grid>
			</Flex>
		</Box>
	);
};
